import { METHOD_GET } from './index';
import { ApiRequestConfigType } from 'requests/index.types';
import { DEFAULT_BASE_URL } from 'config';

export const API_GET_j360ApiVersion: ApiRequestConfigType = {
  __typename: 'LegacyAPI',
  method: METHOD_GET,
  url: `${DEFAULT_BASE_URL}/api_version`,
};
